export default "__VITE_ASSET__ca9bca93__"